import { css } from '@emotion/react'
import { useThemeStore } from '~/components/theme/useThemeStore'
import { createIPadCss } from '~/css/createIPadCss'
import { createMobileCss2 } from '~/css/createMobileCss'
import { AgentCarouselSubscriptionCheck } from '~/modules/auth/components/AgentCarouselSubscriptionCheck'
import { meCheckHandlerCreateByProductNameWithExpiredAt } from '~/modules/SDK/me/meCheckHandlerCreateByProductName'
import { meCreateCheckHandler } from '~/modules/SDK/me/meCreateCheckHandler'
import { store } from '~/pages/heineken_template/_private/store'
import { TemplateProps } from '~/pages/heineken_template/_private/TemplateProps'
import { amyStock_initStrategies } from './amyStock_initStrategies'
import { amyStock_initStyling } from './amyStock_initStyling'
import { AmyStock_SidePane1 } from './amyStock_SidePane1'
import { AmyStock_SidePane2 } from './amyStock_SidePane2'
import { AmyStock_TopBar } from './amyStock_Topbar'

export const amyStock_init = (templateProps: TemplateProps) => {
  amyStock_initStyling(templateProps)
  amyStock_initStrategies()

  useThemeStore.setState({ theme: 'dark' })
  store.charting.setThemeMode('dark')

  templateProps.layout.login = (
    <AgentCarouselSubscriptionCheck resources={[{ image: [true, '/amy/loginView.png'] }]} />
  )

  templateProps.permissions.pageview = meCheckHandlerCreateByProductNameWithExpiredAt('web_stock')

  store.charting.widgetOptions = {
    ...store.charting.widgetOptions,
    custom_css_url: '../../amy/chartingTheme.css',
  }

  store.charting.widgetOptions = {
    ...store.charting.widgetOptions,
    symbol: '2330',
    interval: 'D',
    enableVolumeIndicator: false,
    disabledHeaderWidget: false,
    disabledLeftToolbar: false,
    disabledTimeframesToolbar: true,
    overrides: store.charting.darkOverrides,
    disabledHeaderChartType: true,
    disabledHeaderCompare: true,
    disabledGoToDate: true,
    disabledHeaderSaveload: true,
  }

  templateProps.layout.cssset = css`
    grid-template-rows: 48px 1fr;
    grid-template-columns: 336px 1fr;

    grid-template-areas:
      'Row1 Row1 Row1'
      'Drawer1 Chart Chart'
      'Drawer1 Chart Chart';

    ${createIPadCss(css`
      grid-template-rows: 48px 1fr;
      grid-template-columns: 1fr;
      grid-template-areas:
        'Row1 Row1 Row1'
        'Chart Chart Chart';
    `)}

    ${createMobileCss2(css`
      grid-template-rows: 48px 1fr;
      grid-template-columns: 1fr;
      grid-template-areas:
        'Row1 Row1 Row1'
        'Chart Chart Chart';
    `)}
  `

  templateProps.layout.Row1 = AmyStock_TopBar
  templateProps.layout.Drawer1 = AmyStock_SidePane1
}
